// extracted by mini-css-extract-plugin
export default {"container":"styles_container__UtPU+","_2":"styles__2__cCyK2","_1":"styles__1__PunD+","switchItem":"styles_switchItem__mNLZM"};